import * as Sentry from "@sentry/browser";

function getSentryEnvironment(): string {
  //TODO: Refactor to use environment variables
  return 'PRODUCTION';
}

function isDevelopmentModeActive(): boolean {
    return getSentryEnvironment() !== 'PRODUCTION';
}

Sentry.init({
  dsn: 'https://4100da2b1a6a4ce6a720734f9867a217@sentry.g-portal.com/21',
  release: COMMIT_HASH,
  debug: isDevelopmentModeActive(),
  environment: getSentryEnvironment(),
  ignoreErrors: [
    // Random plugins/extensions
    'top.GLOBALS',
    // cookiefirst api key
    '[CF] Failed to load config files, are you using a correct API key?',
    // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
    'originalCreateNotification',
    'canvas.contentDocument',
    'MyApp_RemoveAllHighlights',
    'http://tt.epicplay.com',
    'Can\'t find variable: ZiteReader',
    'jigsaw is not defined',
    'ComboSearch is not defined',
    'http://loading.retry.widdit.com/',
    'atomicFindClose',
    // Facebook borked
    'fb_xd_fragment',
    // ISP "optimizing" proxy
    // - `Cache-Control: no-transform` seems to reduce this. (thanks @acdha)
    // See http://stackoverflow.com/questions/4113268/how-to-stop-javascript-injection-from-vodafone-proxy
    'bmi_SafeAddOnload',
    'EBCallBackMessageReceived',
    // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
    'conduitPage',
    // Generic error code from errors outside the security sandbox
    // You can delete this if using raven.js > 1.0, which ignores these automatically.
    'Script error.',
  ],
  beforeSend(event) {
    event.extra = {
      ...event.extra,
      localStorage,
    };

    return event;
  },
  denyUrls: [
    // Facebook flakiness
    /graph\.facebook\.com/i,
    // Facebook blocked
    /connect\.facebook\.net\/en_US\/all\.js/i,
    // Woopra flakiness
    /eatdifferent\.com\.woopra-ns\.com/i,
    /static\.woopra\.com\/js\/woopra\.js/i,
    // Chrome extensions
    /extensions\//i,
    /^chrome:\/\//i,
    // Other plugins
    /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
    /webappstoolbarba\.texthelp\.com\//i,
    /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
  ],
  tracesSampleRate: isDevelopmentModeActive() ? 1.0 : 0.01,

  replaysOnErrorSampleRate: 1.0,
  attachStacktrace: true,
  integrations: [
    new Sentry.BrowserTracing(),
    new Sentry.Replay(),
  ],
});

// @ts-ignore
window.Sentry = Sentry;
